module.exports = __webpack_public_path__ + "static/media/no-data-studies.68670ac5.svg";